"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeHierarchy = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let EmployeeHierarchy = class EmployeeHierarchy {
    constructor(id, userId, reportingUserId, createdBy, updatedBy) {
        this.id = id;
        this.userId = userId;
        this.reportingUserId = reportingUserId;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.EmployeeHierarchy = EmployeeHierarchy;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], EmployeeHierarchy.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "user_id", type: "integer",
    }),
    tslib_1.__metadata("design:type", Number)
], EmployeeHierarchy.prototype, "userId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "reporting_user_id", type: "integer" }),
    tslib_1.__metadata("design:type", Number)
], EmployeeHierarchy.prototype, "reportingUserId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", Number)
], EmployeeHierarchy.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar", length: 255, nullable: false }),
    tslib_1.__metadata("design:type", Number)
], EmployeeHierarchy.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], EmployeeHierarchy.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], EmployeeHierarchy.prototype, "updatedAt", void 0);
exports.EmployeeHierarchy = EmployeeHierarchy = tslib_1.__decorate([
    (0, typeorm_1.Entity)("employee_hierarchy"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, Number])
], EmployeeHierarchy);
